module.exports = __webpack_public_path__ + "static/video-photo-1033bbd97dc35584665e397e94702b8c.jpg";